import { apiClient } from "./client";

export async function getDigestSettings(id) {
  const res = await apiClient.post("/dash/digest/settings/get", { id });
  return res.data;
}

export async function saveDigestSettings(id, { enabled, email, alertThresholdPct }) {
  const res = await apiClient.post("/dash/digest/settings/save", {
    id,
    enabled,
    email,
    alertThresholdPct,
  });
  return res.data;
}

export async function suggestDigestThreshold(id) {
  const res = await apiClient.post("/dash/digest/suggest-threshold", { id });
  return res.data;
}

export async function sendTestDigest(id) {
  const res = await apiClient.post("/dash/digest/send-test", { id });
  return res.data;
}
